import { createTheme } from "@mui/material/styles";

const scribeTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#00E5C3", contrastText: "#0A0C12" },
    secondary: { main: "#00B4D8" },
    background: { default: "#08090D", paper: "#111420" },
    text: { primary: "#EEF0F6", secondary: "#949BB8" },
    error: { main: "#FF5E5E" },
    warning: { main: "#F5A623" },
    success: { main: "#22C980" },
    divider: "rgba(255,255,255,0.06)",
  },
  typography: {
    fontFamily: "'DM Sans', sans-serif",
    h1: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h5: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h6: { fontFamily: "'Syne', sans-serif", fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "rgba(17,20,32,0.72)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.11)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          background: "linear-gradient(135deg, #00E5C3, #00B4D8)",
          color: "#0A0C12",
          boxShadow: "0 4px 20px rgba(0,229,195,0.18)",
          "&:hover": {
            boxShadow: "0 6px 32px rgba(0,229,195,0.28)",
            filter: "brightness(1.08)",
          },
          "&:disabled": {
            background: "#272D48",
            color: "#3A3F58",
            boxShadow: "none",
          },
        },
        outlined: {
          borderColor: "rgba(255,255,255,0.11)",
          color: "#949BB8",
          "&:hover": {
            borderColor: "#00E5C3",
            color: "#00E5C3",
            backgroundColor: "rgba(0,229,195,0.08)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#111420",
            borderRadius: 10,
            "& fieldset": { borderColor: "rgba(255,255,255,0.11)" },
            "&:hover fieldset": { borderColor: "rgba(0,229,195,0.4)" },
            "&.Mui-focused fieldset": {
              borderColor: "rgba(0,229,195,0.5)",
              boxShadow: "0 0 0 3px rgba(0,229,195,0.06)",
            },
          },
          "& .MuiInputBase-input": { color: "#EEF0F6", caretColor: "#00E5C3" },
          "& .MuiInputLabel-root": { color: "#5A6080" },
          "& .MuiInputLabel-root.Mui-focused": { color: "#00E5C3" },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#5A6080",
          "&.Mui-checked": { color: "#00E5C3" },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": {
            color: "#00E5C3",
            "& + .MuiSwitch-track": { backgroundColor: "rgba(0,229,195,0.35)" },
          },
        },
        track: { backgroundColor: "#272D48" },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.82rem",
          fontWeight: 700,
          color: "#5A6080",
          textTransform: "none",
          flex: 1,
          minWidth: 0,
          borderRadius: 16,
          padding: "0.55rem 0.9rem",
          transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
          "&:hover": { color: "#949BB8", backgroundColor: "#171B2A" },
          "&.Mui-selected": {
            background: "linear-gradient(135deg, #00E5C3, #00B4D8)",
            color: "#0D0F14",
            boxShadow: "0 2px 20px rgba(0,229,195,0.18)",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          padding: 4,
          backgroundColor: "#111420",
          border: "1px solid rgba(255,255,255,0.06)",
          minHeight: "unset",
        },
        indicator: { display: "none" },
        flexContainer: { gap: 4 },
      },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: "rgba(255,255,255,0.06)" } },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#1E2338",
          color: "#EEF0F6",
          border: "1px solid rgba(255,255,255,0.11)",
          fontSize: "0.78rem",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: { backgroundColor: "#111420" },
        icon: { color: "#5A6080" },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": { backgroundColor: "rgba(0,229,195,0.08)" },
          "&.Mui-selected": {
            backgroundColor: "rgba(0,229,195,0.12)",
            "&:hover": { backgroundColor: "rgba(0,229,195,0.16)" },
          },
        },
      },
    },
  },
});

export default scribeTheme;
